import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { USER_SIZE_SMALL, USER_STATUS_ONLINE } from '../../constants/AppConstants';

import Avatar from '../Avatar';
import UserStatusIcon from '../UserStatusIcon';

import s from './User.css';


const User = ({
                className,
                dataQa,
                firstName,
                fontSizeName,
                fontSizeMention,
                hideAvatar,
                hideCurrentUserIndicator,
                hideMentionName,
                hideStatus,
                isCurrentUser,
                lastName,
                mentionName,
                noPad,
                small,
                status,
                statusMarginRight,
                whiteOfflineStatus,
              }) => (
  <div
    data-qa={dataQa || 'user'}
    className={classnames({
      [className]: !!className,
      [s.user]: true,
      [s.small]: small,
      [s.noPad]: noPad
    })}
  >
    {!hideStatus &&
    <UserStatusIcon
      small={small}
      online={status === USER_STATUS_ONLINE}
      whiteOfflineStatus={whiteOfflineStatus}
      marginRight={statusMarginRight}
    />}
    {!hideAvatar &&
    <Avatar
      firstName={firstName}
      lastName={lastName}
      size={USER_SIZE_SMALL}
    />
    }
    <span
      data-qa="userDisplayName"
      className={classnames([s.displayName, s.truncate])}
      style={fontSizeName && { fontSize: fontSizeName }}
      title={`${firstName} ${lastName}`.trim()}
    >
      {(firstName || lastName) &&
        `${firstName} ${lastName}`.trim()
      }
    </span>
    {!hideMentionName &&
    <span
      data-qa="userMentionName"
      className={classnames([s.mentionName, s.truncate])}
      style={fontSizeMention && { fontSize: fontSizeMention }}
      title={`@${mentionName}`}
    >
      {`@${mentionName}`}
    </span>
    }
    {!hideCurrentUserIndicator && isCurrentUser &&
    <span className={s.currentUserIndicator}>(you)</span>
    }
  </div>
);

User.propTypes = {
  dataQa: PropTypes.string,                 // ID used by QA for automated testing (defaults to 'user')
  firstName: PropTypes.string,              // the first name of the user
  lastName: PropTypes.string,               // the last name of the user
  mentionName: PropTypes.string,            // The mention name of the user
  className: PropTypes.string,              // class name for the component
  fontSizeName: PropTypes.string,           // font size for user name
  fontSizeMention: PropTypes.string,        // font size for mention name
  hideAvatar: PropTypes.bool,               // if true, hides the avatar
  hideCurrentUserIndicator: PropTypes.bool, // if true, hides the current user indicator
  hideMentionName: PropTypes.bool,          // if true, hides the mention name of the user
  hideStatus: PropTypes.bool,               // if true, hides the status icon
  isCurrentUser: PropTypes.bool,            // if true, the user is the currently authenticated user
  noPad: PropTypes.bool,                    // if true, there will be no vertical padding
  small: PropTypes.bool,                    // if true, small styles are used
  status: PropTypes.string,                 // the online status of the user
  statusMarginRight: PropTypes.string,      // custom margin between the status icon and the name of the user
  whiteOfflineStatus: PropTypes.bool,       // if true, a white border is used for offline status
};

export default User;
